import React from "react";
import { SwitchStyled, Text } from "@commonsku/styles";

export default function FillBanner(props) {
  const { value, onChange } = props;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Text
        as="p"
        style={{
          color: "var(--color-neutrals-90)",
          fontFamily: "var(--font-family-regular)",
          fontSize: 16,
          marginBottom: 0,
          width: 144,
        }}
      >
        Fill Banner
      </Text>
      <SwitchStyled
        size="medium"
        selected={+value === 1}
        onClick={() => onChange(+value !== 1 ? 1 : 0)}
      />
    </div>
  );
}
